import React from "react";
import { ic_gps_fixed } from "react-icons-kit/md/ic_gps_fixed";
import { languageService } from "../../../Language/language.service";
import { themeService } from "../../../theme/service/activeTheme.service";
import { maintenaceDetailstyle } from "../../Maintenance/styles/maintenanceDetailstyle";
import SvgIcon from "react-icons-kit";
import { getIssueMPMethods } from "./mileposts";
import { LocPrefixService } from "../../LocationPrefixEditor/LocationPrefixService";
import { versionInfo } from "../../MainPage/VersionInfo";

export const AboveGISLocationClickMethods = {
  selectedAsset: (type, m1) => {
    let selectedAsset = { start: 5, end: 5, icon: "circle-stroked-15" };
    if (type === "GPS") {
      return { type: "GPS", ...splitLocationToGPS(m1.issue.location) };
    }
    if (type === "Milepost") {
      selectedAsset.start = getIssueMPMethods.getIssueFinalStartMP(m1.issue, m1.lineId);
      selectedAsset.end = getIssueMPMethods.getIssueFinalEndMP(m1.issue, m1.lineId);
      selectedAsset.text = m1.issue && m1.issue.unitId;
      selectedAsset.visible = true;
      selectedAsset._id = "Mp_" + m1._id;
      selectedAsset.sPrefix = LocPrefixService.getPrefixMp(selectedAsset.start, m1.lineId);
      selectedAsset.ePrefix = LocPrefixService.getPrefixMp(selectedAsset.end, m1.lineId);
      return selectedAsset;
    }
    return selectedAsset;
  },
};

export const AboveGISMapLocationHelper = (issue, lineId, onClickMethod) => {
  if (!issue) return [];
  let GPSBox = loadGPSBox(() => onClickMethod("GPS"), issue);
  let MpBox = loadMPBox(() => onClickMethod("Milepost"), issue, lineId);
  let MarkerBox = loadMarkerBox(issue);
  let toRet = [];
  GPSBox && toRet.push(GPSBox);
  MpBox && toRet.push(MpBox);
  MarkerBox && toRet.push(MarkerBox);
  return toRet;
};

function loadGPSBox(onClickMethod, issue) {
  if (!issue.location || issue.location === ",") return null;
  let type = "GPS";
  let formattedStr = languageService(type) + ": " + issue.location;
  return commonBox("GPS", ic_gps_fixed, formattedStr, onClickMethod);
}
function loadMPBox(onClickMethod, issue, lineId) {
  if (versionInfo.isReVAMP()) return;
  let issueMp = getIssueMPMethods.getIssueFinalMP(issue, lineId);
  if (!issueMp) return;
  let type = "Milepost";
  let formattedStr = languageService(type) + ": " + issueMp;
  return commonBox("Milepost", ic_gps_fixed, formattedStr, onClickMethod);
}

function loadMarkerBox(issue) {
  let issueMarker = getIssueMPMethods.getIssueMarker(issue);
  if (!issueMarker) return;
  let type = "Marker";
  let formattedStr = languageService(type) + ": " + issueMarker;
  return commonBox(type, null, formattedStr, null, { marginLeft: "41px" });
}

function commonBox(label, icon, formattedStr, onClick, moreStyle) {
  let style = { ...themeService(maintenaceDetailstyle.gpsIconTextStyle), ...moreStyle };
  return (
    <div style={style} key={label}>
      {icon && (
        <button style={themeService(maintenaceDetailstyle.gpsIconStyle)} onClick={onClick || (() => {})}>
          <SvgIcon icon={icon} size={18} />
        </button>
      )}
      {formattedStr}
    </div>
  );
}

function splitLocationToGPS(loc2Add) {
  let locations = loc2Add.split(",");

  let start = { lat: locations[0], lon: locations[1] },
    end = { lat: locations[0], lon: locations[1] };

  if (locations.length > 2) {
    console.log("maintenance service, location parse error: ", loc2Add, "type:", "GIS");
    if (locations.length == 4) {
      end = { lat: locations[2], lon: locations[3] };
    }
  } else {
    start = { lat: locations[0], lon: locations[1] };
    end = { lat: locations[0], lon: locations[1] };
  }
  return { start: start, end: end };
}



// WEBPACK FOOTER //
// ./src/components/Common/services/AboveGISMapLocationHelper.js